import { getCategoryPath, getCategoryName } from '../functions'
import { MappingItem } from '../../GTM'
import { ProductInterface } from '@pylot-data/pylotschema'
import { deepValue } from '@corratech/pylot-utils'

const getIsSaleItem = (data: ProductInterface): number => {
    const finalPrice = deepValue(
        data,
        ['price_range', 'minimum_price', 'final_price', 'value'],
        0
    )
    const regularPrice = deepValue(
        data,
        ['price_range', 'minimum_price', 'regular_price', 'value'],
        0
    )
    return Number(finalPrice) < Number(regularPrice) ? 1 : 0
}

export const pdpData = (
    itemCategoryPath = getCategoryPath,
    categoryName = getCategoryName
): MappingItem => {
    return {
        id: ['sku'],
        name: ['name'],
        discount: ['price_range', 'minimum_price', 'discount', 'amount_off'],
        price: [
            ['price_range', 'minimum_price', 'final_price', 'value'],
            ['price_range', 'minimum_price', 'regular_price', 'value']
        ],
        currencyCode: [
            ['price_range', 'minimum_price', 'final_price', 'currency'],
            ['price_range', 'minimum_price', 'regular_price', 'currency']
        ],
        productType: ['__typename'],
        brand: ['brand_name'],
        is_sale_item: getIsSaleItem,
        category: itemCategoryPath,
        categoryPath: categoryName
    }
}
